// import {
//   TData,
//   TMethod,
//   TPathParams,
//   TPayloadData,
//   TQueryParams,
//   TResponseCode,
// } from "./types";
// import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
//
// import { toast } from "react-toastify";
// import { RemoveData4LogOut } from "contexts/auth/utils";
// import { RequestErrorHandling } from "utils/netCall/utils/errorHandler";
//
// export let abortControllers: Record<string, AbortController>;
//
// // const getAccessToken = async () => {
// //   const storedToken = await SecureStore.getItemAsync("token");
// //   if (storedToken) return `Bearer ${storedToken}`;
// // };
// const removeAccessToken = async () => {
//   // await RemoveData4LogOut();
//   // window.location.href = "/login";
//   window.location.href = "/bff/login?returnUrl=/";
// };
//
// const getRequestHeadersConfigs = async (
//   contentType: "json" | "form-urlencoded" | "upload" = "json"
// ) => {
//   let configs: { [key: string]: string } = {
//     Accept: "*/*",
//     "Cache-Control": "no-cache",
//     //TODO uncomment csrf
//     "X-CSRF": "1",
//     // "X-Domain-Name": window.location.host,
//   };
//   // const accessToken = await getAccessToken();
//   // if (accessToken) {
//   configs = {
//     ...configs,
//     // Authorization: `${accessToken}`,
//   };
//   // }
//   if (contentType === "form-urlencoded") {
//     configs = {
//       ...configs,
//       "Content-Type": "application/x-www-form-urlencoded",
//     };
//   } else if (contentType === "upload") {
//     configs = {
//       ...configs,
//       "Content-Type": "multipart/form-data",
//     };
//   } else {
//     configs = {
//       ...configs,
//       "Content-Type": "application/json",
//     };
//   }
//   return configs;
// };
//
// const apiPathGenerator = (endPoint: string, pathParams?: TPathParams) => {
//   let path = endPoint;
//   if (pathParams) {
//     path = path + "?";
//     Object.keys(pathParams).forEach((key) => {
//       path = path + `${key}:${pathParams[key]}&`;
//     });
//   }
//   return path;
// };
// const getAxiosConfig = async (
//   method: TMethod,
//   endPoint: string,
//   pathParams?: TPathParams,
//   queryParams?: TQueryParams,
//   payloadData?: TPayloadData | TPayloadData[],
//   signalKey?: string
// ) => {
//   if (signalKey) {
//     abortControllers = {
//       ...abortControllers,
//       [signalKey]: new AbortController(),
//     };
//   }
//   const headers =
//     method === "POST-form-urlencoded"
//       ? await getRequestHeadersConfigs("form-urlencoded")
//       : await getRequestHeadersConfigs();
//   let config: AxiosRequestConfig = {
//     url: apiPathGenerator(endPoint, pathParams),
//     // url: endPoint,
//     paramsSerializer: {
//       indexes: null,
//     },
//     headers: headers,
//   };
//   if (method === "GET") {
//     config = {
//       ...config,
//       method: "get",
//       ...(queryParams && { params: queryParams }),
//
//       ...(signalKey && { signal: abortControllers[signalKey].signal }),
//     };
//   } else if (method === "POST") {
//     config = {
//       ...config,
//       method: "post",
//       params: queryParams,
//
//       data: JSON.stringify(payloadData),
//     };
//   } else if (method === "POST-form-urlencoded") {
//     config = {
//       ...config,
//       method: "post",
//       //@ts-ignore
//       data: new URLSearchParams({ ...payloadData }),
//     };
//   } else if (method === "DELETE") {
//     config = {
//       ...config,
//       method: "delete",
//       params: queryParams,
//
//       data: JSON.stringify(payloadData),
//     };
//   } else if (method === "PUT") {
//     config = {
//       ...config,
//       method: "put",
//       params: queryParams,
//
//       data: JSON.stringify(payloadData),
//     };
//   }
//   return config;
// };
//
// type TNetworkCallOptions = {
//   timeCalc?: (time: number) => void;
//   signalKey?: string;
// };
// type TNetworkCallArgs = {
//   method: TMethod;
//   endPoint: string;
//   data?: TData;
//   successCallback?: (response: any) => void;
//   errorCallback?: (response: any) => void;
//   options?: TNetworkCallOptions;
//   preventErrorToast?: boolean;
// };
// export const netCall = async (args: TNetworkCallArgs) => {
//   const { pathParams, queryParams, payloadData } = args.data || {};
//   const {
//     method,
//     endPoint,
//     successCallback,
//     errorCallback,
//     preventErrorToast,
//   } = args;
//   const { timeCalc, signalKey } = args.options || {};
//
//   try {
//     const startRequestTime = Date.now();
//     const axiosConfig = await getAxiosConfig(
//       method,
//       endPoint,
//       pathParams,
//       queryParams,
//       payloadData,
//       signalKey
//     );
//
//     const result = await axios(axiosConfig);
//
//     const finishRequestTime = Date.now();
//
//     timeCalc?.(finishRequestTime - startRequestTime);
//     if (result.status >= 200 && result.status < 400) {
//       if (result.data.responseCode) {
//         if (result.data.responseCode === TResponseCode.OK) {
//           successCallback && successCallback(result.data);
//           return result.data;
//         } else {
//           if (!preventErrorToast) {
//             RequestErrorHandling(result.data);
//           }
//           errorCallback?.(result.data);
//           return result.data;
//         }
//         // successCallback && successCallback(result.data);
//         // return result.data;
//       } else {
//         const resultData = result.data
//         successCallback && successCallback(resultData);
//         return resultData;
//       }
//     }
//   } catch (error: any) {
//     toast.error(error);
//     console.log("!!", error);
//     if (
//       error?.response?.status === 401
//       //   &&
//       // cmd !== "authentication_login_with_credentials"
//     ) {
//       //Todo uncomment
//       removeAccessToken();
//       return error;
//     } else {
//       errorCallback?.(error);
//
//       if (error?.response?.data?.message || error?.response?.data?.error) {
//         !preventErrorToast &&
//           toast.error(
//             `${error?.response?.data?.message || error?.response?.data?.error}`
//           );
//       }
//
//       if (
//         typeof error?.response?.data?.messages === "object" &&
//         error?.response?.data?.messages?.length > 0
//       ) {
//         error?.response?.data?.messages?.map((message: string) => {
//           toast.error(message);
//         });
//       }
//     }
//     return new Error(error);
//     // throw error;
//   }
// };

import { RemoveData4LogOut } from "contexts/auth/utils";
import {
  TErrorMessage,
  TPayloadData,
  TRequestResponseResult,
  TResponseCode,
} from "utils/netCall/types";
import axios from "axios";
import { RequestErrorHandling } from "utils/netCall/utils/errorHandler";
import { toast } from "react-toastify";
import { redirectToBffLogin } from "utils/auth/bffRedirect";

type TNetworkCallArgs<T> = {
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
  endPoint: string;
  body?: TPayloadData | TPayloadData[];
  successCallback?: (data: TRequestResponseResult<T>) => void;
  errorCallback?: (error: TRequestResponseResult<any>) => void;
  preventErrorToast?: boolean;
  logoutOnUnauthorized?: boolean;
};

export const netCall = async <T,>(
  args: TNetworkCallArgs<T>
): Promise<TRequestResponseResult<T>> => {
  const {
    method,
    endPoint,
    successCallback,
    errorCallback,
    preventErrorToast = false,
    logoutOnUnauthorized = true,
    body,
  } = args;

  const responseResult = (
    responseCode: TResponseCode,
    results: T,
    messages: TErrorMessage[] = [],
    isChanged: boolean = false
  ): TRequestResponseResult<T> => {
    return {
      messages: messages,
      responseCode: responseCode,
      isChanged: isChanged,
      results: results,
    };
  };

  try {
    const result = await axios({
      method: method,
      url: endPoint,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF": "1",
      },
      ...(body && { data: body }),
    });
    if (result.status >= 200 && result.status < 400) {
      if (result.data.responseCode) {
        const resultData = responseResult(
          result.data.responseCode,
          result.data.results,
          result.data?.messages,
          result.data?.isChanged
        );
        if (result.data.responseCode === TResponseCode.OK) {
          successCallback && successCallback(resultData);
          return resultData;
        } else {
          if (!preventErrorToast) {
            RequestErrorHandling(result.data);
          }
          errorCallback?.(resultData);
          return resultData;
        }
      } else {
        const resultData = responseResult(TResponseCode.OK, result.data);
        successCallback && successCallback(resultData);
        return resultData;
      }
    }
    return responseResult(
      result.status,
      result.data,
      result.data?.messages,
      result.data?.isChanged
    );
  } catch (error: any) {
    if (error?.response?.status === 401 && logoutOnUnauthorized) {
      RemoveData4LogOut();
      redirectToBffLogin();
    } else {
      const resultData = responseResult(
        error?.status ?? TResponseCode.Error,
        error?.response?.data,
        error?.response?.data?.messages ?? error?.message,
        error?.response?.data?.isChanged
      );
      errorCallback?.(resultData);
      if (error?.response?.data?.messages) {
        !preventErrorToast && toast.error(error?.response?.data?.messages);
      } else if (error?.message) {
        !preventErrorToast && toast.error(error?.message);
      }
    }
    return responseResult(
      error?.status ?? TResponseCode.Error,
      error?.response?.data,
      error?.response?.data?.messages,
      error?.response?.data?.isChanged
    );
  }
};
